<template>
  <div class="video-slide" v-if="isValidProgress">
    <canvas-scrolly-video v-if="isMobileWidth || attributes.useimages"
      @canplaythrough="onCanPlayThrough"
      :src="getCanvasScrollySource(attributes.src)"
      :progress="progress"
      :range="attributes.range.split(',').map(i => parseInt(i))"
      :ai2htmlsrc="getAi2htmlSrc(attributes.ai2htmlsrc)"
      @changeaspectratio="function(val){$emit('changeaspectratio', val)}"></canvas-scrolly-video>
    <!-- <scrolly-video v-if="!isMobileWidth && !attributes.useimages" :src="attributes.src" :poster="attributes.videoposter" :progress="progress" @canplaythrough="onCanPlayThrough" :slidenum="slidenum" :slideIndex="slideIndex"></scrolly-video> -->
  </div>
</template>

<script>
import ScrollyVideo from "./ScrollyVideo.vue";
import CanvasScrollyVideo from "./CanvasScrollyVideo.vue";

export default {
  props: ["attributes", "progress", "slidenum", "slideIndex"],
  components: { ScrollyVideo, CanvasScrollyVideo },
  computed: {
    isMobileWidth() {
      // return this.$window.innerWidth < 420 || this.$window.innerHeight < 420;
      return this.$window.innerWidth < 420
    },
    isValidProgress() {
      return !isNaN(this.progress);
    },
  },
  methods: {
    onCanPlayThrough() {
      this.$emit("slideLoaded");
    },
    getCanvasScrollySource(videoSrc) {
      const [path, ext] = videoSrc.split(".");
      return `${path}`;
    },
    getAi2htmlSrc(src){
      return src ? "https://www.straitstimes.com/multimedia/graphics/assets/ai2html/" + src : ""
    },
  },
};
</script>

<style lang="scss">
.video-slide {
  & > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
}
</style>
